import {Component, OnInit} from '@angular/core';
import {ToastDescription, Toaster, Type} from './Toaster';
import {animate, keyframes, style, transition, trigger} from '@angular/animations';
import Timer = NodeJS.Timer;

@Component({
    selector: 'app-toaster',
    templateUrl: 'toaster.component.html',
    styleUrls: ['toaster.component.css'],
    animations: [
        trigger('state', [
            transition(':enter', [
                animate(300, keyframes([
                    style({opacity: 0, transform: 'translateY(-100%)', offset: 0}),
                    style({opacity: 1, transform: 'translateY(15px)', offset: 0.3}),
                    style({opacity: 1, transform: 'translateY(0)', offset: 1.0})
                ]))
            ]),
            transition(':leave', [
                animate(300, keyframes([
                    style({opacity: 1, transform: 'translateY(0)', offset: 0}),
                    style({opacity: 1, transform: 'translateY(-15px)', offset: 0.7}),
                    style({opacity: 0, transform: 'translateY(100%)', offset: 1.0})
                ]))
            ])
        ])
    ]
})

export class ToasterComponent implements OnInit {
    public type: Type;
    public text: string;
    private timeout: Timer;

    private readonly ENTRY_DELAY = 1000;
    private readonly TIMEOUT_IN_MILLIS = 20000;

    public ngOnInit() {
        Toaster.toastDescription.subscribe((description: ToastDescription) => {
            this.dismiss();
            setTimeout(() => {
                this.text = description.text;
                this.type = description.type;
            }, this.ENTRY_DELAY);

            const timeoutInMillis = description.type === Type.NonDismissibleAlert ? Infinity : this.TIMEOUT_IN_MILLIS;
            this.timeout = setTimeout(() => {
                this.removeExistingToast();
            }, timeoutInMillis);
        });
    }

    public dismiss() {
        this.removeExistingToast();
        this.clearTimeout();
    }

    private removeExistingToast(): void {
        this.text = undefined;
        this.type = undefined;
    }

    private clearTimeout() {
        clearTimeout(this.timeout);
        this.timeout = undefined;
    }
}